import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePermission } from "../../../hooks/usePermission";
import AccessDenied from "./AccessDenied";

const ProtectedRoute = ({
  component: Component,
  module,
  action = "view",
  ...rest
}) => {
  const { loggedIn } = useSelector((state) => state.user);
  const { hasPermission, isSuperAdmin } = usePermission();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!loggedIn) {
          return <Redirect to="/admin/login" />;
        }
        if (isSuperAdmin || !module || hasPermission(module, action)) {
          return <Component {...props} />;
        }
        return <AccessDenied />;
      }}
    />
  );
};

export default ProtectedRoute;
